import React, {Component, ReactElement, ReactNode} from 'react'
import NatTokenRepo from '../token/repository/NatTokenRepo'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import {ContentsMainTitle, IconFont, MainContainer} from '../../../styledComponents/ContentsArea'

import {DisplayBlockDiv, DisplayItemSelect, DisplayItemSelectIcon} from '../../../styledComponents/DisplayItem'
import {
    StyledDiv,
    StyledI,
    StyledSelect,
    StyledTable,
    StyledTd,
    StyledTr,
} from '../../../styledComponents/StyledTypeDefinitions';
import styled from 'styled-components';
import {INFOMATION_TYPE, MANSION_CATEGORY} from '../../../CodeMaster';
import NatApartAssocInfoRepo from './repository/NatApartAssocInfoRepo';
import {OptionProps} from '../../../components/shared/forms/PPSelect';
import {Nullable} from '../../../app/TypeHelpers';
import {ApartAssocInfo, NatGetApartAssocInfoList, SearchCondition} from './repository/NatGetApartAssocInfoList';
import {SortOrder} from '../../../components/shared/SortOrder';
import {NatGetApartAssocInfo, PublishMaterialInfo} from './repository/NatGetApartAssocInfo';
import {generateMedia} from 'styled-media-query';
import {BreakPoint} from '../../../styledComponents/Constants';
import NatAccordionApartAssocComponent from '../common/resident/NatAccordionApartAssocComponent';
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime';
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo';
import {formatForDateInput} from '../../../formatters/formatDate';
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage';
import {NatAsyncCallFunction} from '../../common/util/Natutil';
import {isIE} from 'react-device-detect';
import {Link} from '@mui/material';
import {Location} from 'react-router-dom'


interface Props {
    apartAssocInfoRepo: NatApartAssocInfoRepo,
    currentDateTimeRepo: NatCurrentDateTimeRepo,
    tokenRepo: NatTokenRepo,
    roomToResidentRepo: NatRoomToResidentRepo,
    location: Location
}

interface States {
    searchCondition: SearchCondition
    searchConditionPageInfo: {}
    searchConditionSortInfo: SortOrder[]
    apartAssocInfo: ApartAssocInfo[]
    publishMaterialInfo: { [key: string]: PublishMaterialInfo[] }
    isLoadCompleted: boolean
    getApartAssocCategory: string[]
    openApartAssocStatus: { [key: string]: boolean }
}

class NatResidentApartInfoPage extends Component<Props & ResidentPagePropsSet, States> {
    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            searchCondition: {
                infoCategoryId: INFOMATION_TYPE.APART_INFO.value,
            },
            searchConditionPageInfo: {},
            searchConditionSortInfo: [
                new SortOrder('sortOrder', 'asc'),
                new SortOrder('updateDatetime', 'desc'),
            ],
            apartAssocInfo: [],
            publishMaterialInfo: {'': []},
            isLoadCompleted: false,
            getApartAssocCategory: [],
            openApartAssocStatus: {},
        }

        this.searchApartAssocInfo = this.searchApartAssocInfo.bind(this)
        this.onClickSearchButton = this.onClickSearchButton.bind(this)
        this.onChangeCategory = this.onChangeCategory.bind(this)
        this.renderAccordionContents = this.renderAccordionContents.bind(this)

    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await NatAsyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(
                    this.props.currentDateTimeRepo), this.props.navigate)

            if (currentDateTime && currentDateTime.details) {
                const searchCondition: SearchCondition = this.state.searchCondition
                searchCondition.publishStartDate =
                    formatForDateInput(`${currentDateTime.details.currentDateTime}+09:00`)
                searchCondition.publishEndDate =
                    formatForDateInput(`${currentDateTime.details.currentDateTime}+09:00`)

                await this.searchApartAssocInfo(searchCondition, true)
                this.setState({searchCondition: searchCondition})
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    async searchApartAssocInfo(searchCondition: SearchCondition, initialDisplay?: boolean): Promise<void> {
        if (!initialDisplay) {
            await this.props.eventEmitter.showLoading()
        }
        try {
            const response: Nullable<NatGetApartAssocInfoList> = await NatAsyncCallFunction(
                this.props.apartAssocInfoRepo.getApartAssocInfoList.bind(
                    this.props.apartAssocInfoRepo,
                    searchCondition,
                    undefined,
                    this.state.searchConditionSortInfo), this.props.navigate)

            if (response && response.details) {
                const getApartAssocCategory: string[] = this.state.getApartAssocCategory
                if (getApartAssocCategory.length === 0) {
                    response.details.apartAssocInfo.map((apartAssoc) => {
                        getApartAssocCategory.push(apartAssoc.categoryId)
                    })
                }

                this.setState({
                    apartAssocInfo: response.details.apartAssocInfo,
                    getApartAssocCategory: getApartAssocCategory,
                })
            }
        } finally {
            if (!initialDisplay) {
                this.props.eventEmitter.closeLoading()
            }
        }
    }

    async onClickSearchButton(apartAssocId: string): Promise<void> {
        const openApartAssocStatus: { [key: string]: boolean } =
            JSON.parse(JSON.stringify(this.state.openApartAssocStatus))

        if (openApartAssocStatus[apartAssocId]) {
            delete openApartAssocStatus[apartAssocId]
        } else {
            openApartAssocStatus[apartAssocId] = true
            await this.props.eventEmitter.showLoading()
            try {
                const response: Nullable<NatGetApartAssocInfo> = await NatAsyncCallFunction(
                    this.props.apartAssocInfoRepo.getApartAssocInfo.bind(
                        this.props.apartAssocInfoRepo,
                        apartAssocId), this.props.navigate)

                const publishMaterialInfo: { [key: string]: PublishMaterialInfo[] } = this.state.publishMaterialInfo

                if (response && response.details) {
                    publishMaterialInfo[apartAssocId] = response.details.publishMaterialInfo
                    this.setState({publishMaterialInfo: publishMaterialInfo})
                }
            } finally {
                this.props.eventEmitter.closeLoading()
            }
        }
        this.setState({openApartAssocStatus: openApartAssocStatus})
    }

    onChangeCategory(event: React.ChangeEvent<{ value: unknown }>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.categoryId = event.target.value as string
        this.setState({
            searchCondition: searchCondition,
        })
        this.searchApartAssocInfo(searchCondition)
    }

    renderAccordionContents(apartAssocInfoId: string): ReactElement {
        return <>
            <StyledFileTable>
                {this.state.publishMaterialInfo[apartAssocInfoId] &&
                    this.state.publishMaterialInfo[apartAssocInfoId].map((file, key) => {
                        return <>
                            <StyledFileTr key={key}>
                                <StyledFileTd><img
                                    src={`/resources/images/icons/icon_pdf.png`}
                                    alt=""
                                /></StyledFileTd>
                                <StyledFileTd>
                                    {(isIE) ?
                                        <LinkUnderLine onClick={() => window.open(file.path)}
                                                       target={'_blank'}>
                                            {file.publishMaterialName}
                                        </LinkUnderLine>
                                        :
                                        <Link href={file.path} target={'_blank'} underline="hover">
                                            {file.publishMaterialName}
                                        </Link>
                                    }
                                </StyledFileTd>
                            </StyledFileTr>
                        </>
                    })}
            </StyledFileTable>
        </>
    }

    renderCategorySelect(): ReactNode {
        let tmpCategoryTypeList: OptionProps[]
        tmpCategoryTypeList = MANSION_CATEGORY.values().map((mansion) => {
            return ({
                label: `${mansion.label}`,
                value: `${mansion.value}`,
            })
        })

        const categoryTypeList: OptionProps[] = []
        tmpCategoryTypeList.map((option) => {
            if (this.state.getApartAssocCategory.indexOf(option.value) >= 0) {
                categoryTypeList.push(option)
            }
        })

        let categoryOptions: OptionProps[]
        if (categoryTypeList.length > 0) {
            categoryOptions = [{
                label: 'すべてを表示',
                value: '',
            }, ...categoryTypeList]
        } else {
            categoryOptions = [{
                label: 'すべてを表示',
                value: '',
            }]
        }

        return (
            <CategorySelectIcon>
                <CategorySelect onChange={this.onChangeCategory}>
                    {categoryOptions.map((category, key) => {
                        return (
                            <option value={category.value} key={category.label + key}>{category.label}</option>
                        )
                    })}
                </CategorySelect>
            </CategorySelectIcon>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <ContentsMainTitle><TitleIcon/>マンション情報</ContentsMainTitle>
                <MainContainer>
                    <DisplayBlockDiv>
                        {this.renderCategorySelect()}
                    </DisplayBlockDiv>
                    {(this.state.apartAssocInfo.length > 0) ?
                        this.state.apartAssocInfo.map((apartAssoc, key) => {
                            return (
                                <AccordionBlock key={key}
                                                onClick={() => this.onClickSearchButton(apartAssoc.apartAssocInfoId)}>
                                    <NatAccordionApartAssocComponent
                                        summary={apartAssoc.title}
                                        renderDetails={this.renderAccordionContents}
                                        targetId={apartAssoc.apartAssocInfoId}/>
                                </AccordionBlock>
                            )
                        }) : <>選択条件のマンション情報はありません</>
                    }
                </MainContainer>
            </>
        )
    }
}

export default createResidentPage(NatResidentApartInfoPage)

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

// アコーディオン
const AccordionBlock: StyledDiv = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
`
const StyledFileTable: StyledTable = styled.table`
  border: none;
`
const StyledFileTr: StyledTr = styled.tr`
  border: none;
`
const StyledFileTd: StyledTd = styled.td`
  border: none;
`

// タイトルアイコン
const TitleIcon: StyledI = styled.i`
  ${IconFont};
  font-size: 6.0rem;
  padding-right: 15px;
  color: #5caace;

  &::before {
      content: "\f102";
  }
`
const CategorySelect: StyledSelect = styled(DisplayItemSelect)`
    width: 30%
  ${breakPoint.lessThan('sp')`
    width: 85%
  `}
`
const CategorySelectIcon = styled(DisplayItemSelectIcon)`
  &:after {
    right: 72%;
  }

  ${breakPoint.lessThan('sp')`
     &:after {
        right: 20%;
    }
  `}
`
const LinkUnderLine = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
`
